var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-save',{attrs:{"modelName":"Tipo de Não Conformidade","saveUrl":"nonconformity-types/","id":_vm.$route.params.id,"operation":"put","backUrl":"/nonconformity-types","icon":"fa-list-ul"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dfe0559","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NonconformityType/Edit.vue
// module id = null
// module chunks = 